import { apiWithRetry, retryConfigs } from '../api/axios';
import api from '../api/axios';

export interface ProfitData {
  id: number;
  min_num: number;
  max_num: number;
  bilv: number;
}

export interface ProfitResponse {
  code: number;
  message: string;
  data: ProfitData[];
}

export const getProfitRules = async (): Promise<ProfitResponse> => {
  try {
    const response = await api.get('/profit/rules');
    return response.data;
  } catch (error) {
    console.error('Error fetching profit rules:', error);
    throw error;
  }
};

export const createProfitRate = async (data: Omit<ProfitData, 'id'>): Promise<ProfitResponse> => {
  try {
    const response = await api.post('/profit/create', data);
    return response.data;
  } catch (error) {
    console.error('Error creating profit rate:', error);
    throw error;
  }
};

export const updateProfitRate = async (data: ProfitData): Promise<ProfitResponse> => {
  try {
    const response = await api.put('/profit/update', data);
    return response.data;
  } catch (error) {
    console.error('Error updating profit rate:', error);
    throw error;
  }
};

export const deleteProfitRate = async (id: number): Promise<ProfitResponse> => {
  try {
    const response = await api.delete(`/profit/delete/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting profit rate:', error);
    throw error;
  }
}; 